import { render, staticRenderFns } from "./TaskListTab.vue?vue&type=template&id=f53a512e&scoped=true&"
import script from "./TaskListTab.vue?vue&type=script&lang=js&"
export * from "./TaskListTab.vue?vue&type=script&lang=js&"
import style0 from "./TaskListTab.vue?vue&type=style&index=0&id=f53a512e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f53a512e",
  null
  
)

export default component.exports